import GenericExporter from './generic';
import FountainConverter from 'fountain-to-json';

class FountainToJSONExporter extends GenericExporter {
	constructor() {
		super();
		this.converter = new FountainConverter();
	}
	getName() {
		return 'Fountain to JSON';
	}

	getDescription() {
		return `Converts a fountain script into a JSON file 
		that can be parsed by games to produce non-branching dialogues.`;
	}

	getFileType() {
		return '.json';
	}

	getMimeType() {
		return 'application/json';
	}

	export(text) {
		return new Promise((resolve, reject) => {
			const output = this.converter.parse(text);
			if (output instanceof Error) {
				reject(output);
			}
			else {
				resolve(JSON.stringify(output, false, 2));
			}
		});
	}
}

export default FountainToJSONExporter;


// WEBPACK FOOTER //
// ./src/exporters/fountain-to-json.js